import { useCallback, useEffect, useState } from "react";
import { NavLink, useLocation, useHistory } from "react-router-dom";
import Social from "./Social";
import externalUrls from "./externalUrls";
import { ReactComponent as StakeIcon } from "../../assets/icons/stake.svg";
import { ReactComponent as BondIcon } from "../../assets/icons/bond.svg";
import { ReactComponent as DashboardIcon } from "../../assets/icons/dashboard.svg";
//import { ReactComponent as PoolTogetherIcon } from "../../assets/icons/33-together.svg";
import { ReactComponent as IdoIcon } from "../../assets/icons/ido.svg";
// import { ReactComponent as IgoIcon } from "../../assets/icons/igo.svg";
import { ReactComponent as CalculatorIcon } from "../../assets/icons/calculator.svg";
import { ReactComponent as DocsIcon } from "../../assets/icons/book.svg";

import { trim, shorten } from "../../helpers";
import { useAddress, useWeb3Context } from "src/hooks/web3Context";
import useBonds from "../../hooks/Bonds";
import { Paper, Link, Box, Typography, SvgIcon, Icon } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import "./sidebar.scss";
import logo from "../../assets/images/logo.png";
import logo2 from "../../assets/images/logo.png";

import { useTranslation } from 'react-i18next';
import useInvite from '../../hooks/useInvite'

function NavContent({ theme, showPerformance }) {
  const [isActive] = useState();
	const {pathname} = useLocation()
  const history = useHistory()
  const address = useAddress();
  const { nodeAddress, gcAddress } = useInvite()
  
  const { t } = useTranslation();

  const [sidbarRoute, setSidbarRoute] = useState('')

  const logoIcon = theme === "light" ? logo2 : logo;

  const checkPage = useCallback((match, location, page) => {
    const currentPath = location.pathname.replace("/", "");

    if (currentPath.indexOf("dashboard") >= 0 && page === "dashboard") {
      return true;
    }
    if (currentPath.indexOf("ido") >= 0 && page === "ido") {
      return true;
    }
    if (currentPath.indexOf("snowglobe") >= 0 && page === "snowglobe") {
      return true;
    }
    if (currentPath.indexOf("stake") >= 0 && page === "stake") {
      return true;
    }
    if ((currentPath.indexOf("bonds") >= 0 || currentPath.indexOf("choose_bond") >= 0) && page === "bonds") {
      return true;
    }
    if (currentPath.indexOf("invite") >= 0 && page === "invite") {
      return true;
    }
    if (currentPath.indexOf("governance") >= 0 && page === "governance") {
      return true;
    }
    if (currentPath.indexOf("redeem") >= 0 && page === "redeem") {
      return true;
    }
    if (currentPath.indexOf("tokenSwap") >= 0 && page === "tokenSwap") {
      return true;
    }
    return false;
  }, []);

  useEffect(() => {
    if(pathname === '/genesis') {
      if(address && (nodeAddress || gcAddress) && showPerformance) {

      } else {
        history.push('/404')
      }
    }
  }, [pathname])

  return (
    <Paper className="dapp-sidebar">
      <Box className="dapp-sidebar-inner" display="flex" justifyContent="space-between" flexDirection="column">
        <div className="dapp-menu-top">
          {/* <Box className="branding-header">
            <Link href="https://indao.money/" target="_blank">
              <img src={logoIcon}></img>
            </Link>

            {address && (
              <div className="wallet-link">
                <Link href={`https://ftmscan.com/address/${address}`} target="_blank">
                  {shorten(address)}
                </Link>
              </div>
            )}
          </Box> */}

          <div className="dapp-menu-links">
            <div className="dapp-nav" id="navbarNav">
            <Link
                component={NavLink}
                id="dash-nav"
                to="/ido"
                isActive={(match, location) => {
                  setSidbarRoute(location.pathname)
                  return checkPage(match, location, "ido");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""}`}
              >
                <div style={{ display: "flex" }}>
                  <Typography variant="h6" className="Arial-Black">
                    {t('menu.ido')}
                  </Typography>
                </div>
              </Link>

              <Link
                component={NavLink}
                id="dash-nav"
                to="/dashboard"
                isActive={(match, location) => {
                  setSidbarRoute(location.pathname)
                  return checkPage(match, location, "dashboard");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""}`}
              >
                <div style={{ display: "flex" }}>
                  <Typography variant="h6" className="Arial-Black">
                    {t('menu.dashboard')}
                  </Typography>
                </div>
              </Link>

              <Link
                component={NavLink}
                id="snowglobe-nav"
                to="/snowglobe"
                isActive={(match, location) => {
                  return checkPage(match, location, "snowglobe");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""}`}
              >
                <div style={{ display: "flex" }}>
                  <Typography variant="h6" className="Arial-Black">
                    {t('menu.calculator')}
                  </Typography>
                </div>
              </Link>

              <Link
                component={NavLink}
                id="stake-nav"
                to="/stake"
                isActive={(match, location) => {
                  setSidbarRoute(location.pathname)
                  return checkPage(match, location, "stake");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""}`}
              >
                <div style={{ display: "flex" }}>
                  <Typography variant="h6" className="Arial-Black">
                    {t('menu.stake')}
                  </Typography>
                </div>
              </Link>

              <Link
                component={NavLink}
                id="bond-nav"
                to="/bonds"
                isActive={(match, location) => {
                  return checkPage(match, location, "bonds");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""}`}
              >
                <div style={{ display: "flex" }}>
                  <Typography variant="h6" className="Arial-Black">
                    {t('menu.bond')}
                  </Typography>
                </div>
              </Link>

              <Link
                component={NavLink}
                id="invite-nav"
                to="/invite"
                isActive={(match, location) => {
                  return checkPage(match, location, "invite");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""}`}
              >
                <div style={{ display: "flex" }}>
                  <Typography variant="h6" className="Arial-Black">
                    {t('menu.invite')}
                  </Typography>
                </div>
              </Link>
              
              {
                address && (nodeAddress || gcAddress) && showPerformance ?
                <Link
                component={NavLink}
                id="genesis-nav"
                to="/genesis"
                isActive={(match, location) => {
                  return checkPage(match, location, "genesis");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""}`}
              >
                <div style={{ display: "flex" }}>
                  <Typography variant="h6" className="Arial-Black">
                    DC&GC
                  </Typography>
                </div>
              </Link> : null}

              <Link
                component={NavLink}
                id="tokenSwap-nav"
                to="/tokenSwap"
                isActive={(match, location) => {
                  return checkPage(match, location, "tokenSwap");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""}`}
              >
                <div style={{ display: "flex" }}>
                  <Typography variant="h6" className="Arial-Black">
                    {t('menu.tokenSwap')}
                  </Typography>
                </div>
              </Link>

              <Link href={'https://docs.morgandao.money/'} target="_blank">
                <div style={{ display: "flex" }}>
                  <Typography variant="h6" className="Arial-Black">
                    {t('menu.docs')}
                  </Typography>
                </div>
              </Link>

              {/* <Link
                component={NavLink}
                id="redeem-nav"
                to="/redeem"
                isActive={(match, location) => {
                  return checkPage(match, location, "redeem");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""}`}
              >
                <div style={{ display: "flex" }}>
                  <Typography variant="h6" className="Arial-Black">
                    {t('menu.redeem')}
                  </Typography>
                </div>
              </Link> */}

            </div>
          </div>
        </div>

        <div className="dapp-menu-social">
          <Social />
        </div>

      </Box>
    </Paper>
  );
}

export default NavContent;
